export { OrganisationDetailPage } from './src/organisation-detail-page';
